import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import {
  DetailsList,
  DetailsListLayoutMode,
  CheckboxVisibility,
} from 'office-ui-fabric-react/lib/DetailsList';

import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

import { localizable } from 'components/Localization';
import { computed } from 'mobx';

@localizable
@observer
class CsvMappingTable extends Component {
  @computed get mainFields() {
    const { fields } = this.props;
    return _.pickBy(fields, (field) => !field.additional);
  }

  @computed get additionalFields() {
    const { fields } = this.props;
    return _.pickBy(fields, (field) => field.additional);
  }

  handleChangeMapping = (index) => (ev, option, _index, value) => {
    const { mapping } = this.props;
    mapping[index] = option.key;
  };

  handleRenderDetailsHeader = (props, defaultRenderer) => {
    props.onRenderColumnHeaderTooltip = this.handleRenderColumnHeaderTooltip;
    return defaultRenderer(props);
  };

  handleRenderColumnHeaderTooltip = (props) => {
    const { mapping, t } = this.props;
    if (props.content === 'additional') return '';
    return (
      <Dropdown
        defaultSelectedKey={mapping[props.content]}
        options={[{ key: '', text: `-- ${t('do not import')} --` }].concat(
          _.map(this.mainFields, (field, key) => {
            return { key, text: field.title };
          })
        )}
        onChange={this.handleChangeMapping(props.content)}
      />
    );
  };

  handleRenderItemColumn = (item, index, column) => {
    const { fields, mapping } = this.props;
    if (column.key === 'additional') {
      const additional = [];
      mapping.forEach((m, _index) => {
        if (m && this.additionalFields[m] && fields[m].title && !!item[_index])
          additional.push(`${fields[m].title}: ${item[_index]}`);
      });
      const content = additional.join('\n');
      return <Icon iconName="More" title={content} />;
    }
    const content = item[column.key];
    return <span>{content}</span>;
  };

  render() {
    const { data, fields, mapping } = this.props;

    let columns = mapping.map((m, index) => {
      return {
        key: index,
        name: `Column ${index}`,
        data: 'string',
        minWidth: 120,
        maxWidth: 150,
        ariaLabel: index, // this is passed to the handleRenderColumnHeaderTooltip as props.content
        additional: typeof fields[m] !== 'undefined' && fields[m].additional,
      };
    });

    // filter out mapped additional fields, as these shall not be used for main mapping
    columns = _.filter(columns, (column) => !column.additional);

    const hasAdditional = _.some(fields, (field) => field.additional);
    if (hasAdditional)
      columns.push({
        key: 'additional',
        name: 'Additional',
        data: 'string',
        minWidth: 40,
        maxWidth: 40,
        ariaLabel: 'additional',
      });

    return (
      <DetailsList
        columns={columns}
        items={data}
        onRenderItemColumn={this.handleRenderItemColumn}
        onRenderDetailsHeader={this.handleRenderDetailsHeader}
        checkboxVisibility={CheckboxVisibility.hidden}
        layoutMode={DetailsListLayoutMode.justified}
      />
    );
  }
}

export default CsvMappingTable;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/BulkRegistration/CsvMappingTable.jsx